// import { Navigate } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem("catalyzeToken");
//   return isAuthenticated ? children : <Navigate to="/login" />;
// };

// export default ProtectedRoute;



import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem("catalyzeToken");

  useEffect(() => {
    let interval;

    const verifyUser = async () => {
      try {
        await axios.get(`${BaseUrl}api/rbac/my-permissions`, {
          headers: {
            "x-access-token": token,
            "x-password-check": "strict",
          },
        });

        setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("catalyzeToken");
          localStorage.removeItem("username");
          localStorage.removeItem("email");
          setIsValid(false);
        } else {
          setIsValid(true);
        }
      }
    };

    if (token) {
      verifyUser();
      interval = setInterval(() => {
        verifyUser();
      }, 600000); // Strict password check every 10 minutes
    } else {
      setIsValid(false);
    }

    // 👉 Cleanup (VERY IMPORTANT)
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [token]);

  useEffect(() => {
    const expire = () => {
      localStorage.removeItem("catalyzeToken");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      setIsValid(false);
    };
    window.addEventListener("catalyze:session-expired", expire);
    return () => window.removeEventListener("catalyze:session-expired", expire);
  }, []);

  // ⏳ While checking
  if (isValid === null) {
    return <div>Loading...</div>;
  }

  // ❌ Not valid → redirect
  if (!isValid) {
    return <Navigate to="/login" />;
  }

  // ✅ Valid
  return children;
};

export default ProtectedRoute;
